export enum IChatActionTypes {
  FETCH_CHATROOMS_REQUEST = "FETCH_CHATROOMS_REQUEST",
  FETCH_CHATROOMS_SUCCESS = "FETCH_CHATROOMS_SUCCESS",
  FETCH_CHATROOMS_FAILURE = "FETCH_CHATROOMS_FAILURE",

  FETCH_THREADSLIST_REQUEST = "FETCH_THREADSLIST_REQUEST",
  FETCH_THREADSLIST_SUCCESS = "FETCH_THREADSLIST_SUCCESS",
  FETCH_THREADSLIST_FAILURE = "FETCH_THREADSLIST_FAILURE",

  UPDATE_CHANGEEVENT_FOR_CHAT = "UPDATE_CHANGEEVENT_FOR_CHAT",


   UPDATE_TASK_UPDATES = "UPDATE_TASK_UPDATES",
   TOGGLE_REVERSE_PROXY = "TOGGLE_REVERSE_PROXY",
   TOGGLE_USER_AVATAR_CHANGE = "TOGGLE_USER_AVATAR_CHANGE",
}

export interface IChatRoomData {
  data: IChatRoom[];
  is_admin: boolean;
  success: boolean;
}

export interface IChatRoom {
  id: string;
  room_name: string;
  admin_members: IAdminMember[];
  created_by: string;
  unread_count: number;
  opened_threads: number;
}

export interface IAdminMember {
  id: string;
  name: string;
}

export interface IThreadListData {
  data: IThreadList[];
  is_admin: boolean;
  read_count: number;
  success: boolean;
  total_count: number;
  unread_count: number;
}

export interface IThreadList {
  id: string;
  thread_id: string;
  message: string;
  created_at: string;
  replies_count: number;
  is_closed: boolean;
  unread_count: number;
  created_by: string;
  created_by_name: string;
}

export interface IStoreFile {
  storage_prefix: string;
  success: boolean;
  thumbnail_prefix: string;
}
